import { InvoiceReportsTable } from '@/features/invoice_reports/components/List/Table/Table';
import { FC, memo, useMemo } from 'react';

type ErrorInvoiceReportsTableProps = {
  error: Error | null;
};

export const ErrorInvoiceReportsTable: FC<ErrorInvoiceReportsTableProps> = memo(
  () => {
    const pagination = useMemo(
      () => ({
        currentPage: 1,
        maxPage: 1,
        perPage: 1,
        maxRecord: 0,
      }),
      []
    );
    const tableProps = useMemo(
      () => ({ data: [], loading: false, emptyType: 'error' }),
      []
    );
    return (
      <InvoiceReportsTable
        table={tableProps}
        pagination={pagination}
        isSearchEmpty={false}
      />
    );
  }
);
ErrorInvoiceReportsTable.displayName = 'ErrorInvoiceReportsTable';
